/* c8 ignore start */
import { SAT_SERVICE } from "@/utils/services";

const customerRoutes = {
  path: "/customer",
  component: () => import("@/layouts/Customer/CustomerLayout.vue"),
  children: [
    {
      path: "report_manager",
      name: "customer-report_manager",
      component: () =>
        import(
          "@/modules/ReportManager/views/customer/report-manager/report-manager.index.vue"
        ),
      meta: {
        solutionId: SAT_SERVICE,
      },
      children: [],
    },
  ],
};

export { customerRoutes };

export default {};
/* c8 ignore end */
